import React, { useState, useEffect } from "react";
import NavBar from "../components/NavBar/NavBar";
import NavbarSingle from "../components/NavBar/NavbarSingle";
import { useViewer, VIEWER_ROLES } from "../utils/ViewerContext";
import "../styles/global.css";

const DefaultLayout = ({ children, setLanguage }) => {
  const { role } = useViewer();
  // xsscan/xsinfo get the same minimal chrome (emblem + logout, no admin
  // nav links) as the existing single-event deep-link flow — they're a
  // single-purpose account, not an admin browsing multiple sections.
  const isSingle =
    localStorage.getItem("single") === "true" ||
    role === VIEWER_ROLES.XSSCAN ||
    role === VIEWER_ROLES.XSINFO;
  const [navWidth, setNavWidth] = useState(0);
  const [offset, setOffset] = useState(60);

  useEffect(() => {
    const updateOffset = () => {
      const screenWidth = window.innerWidth;
      setOffset(screenWidth <= 999 ? 0 : screenWidth <= 1399 ? 30 : 60);
      setNavWidth(screenWidth <= 999 ? 0 : navWidth);
    };

    updateOffset();
    window.addEventListener("resize", updateOffset);

    return () => {
      window.removeEventListener("resize", updateOffset);
    };
  }, []);

  return (
    <div className="width-100 app-container">
      {!isSingle ? (
        <NavBar setLanguage={setLanguage} setNavWidth={setNavWidth} />
      ) : (
        <NavbarSingle setNavWidth={setNavWidth} setLanguage={setLanguage} />
      )}

      <div
        className={`app-content`}
        style={{ marginLeft: `${navWidth + offset}px` }}
      >
        {children}
      </div>
    </div>
  );
};

export default DefaultLayout;
